import { ArrowLeftIcon, Compass } from "lucide-react";

export function NotFoundPage({ onGoHome }: { onGoHome: () => void }) {
  return (
    <div style={{ minHeight: "100svh", display: "grid", placeItems: "center", padding: "2rem 1.25rem" }}>
      <div className="cb-panel cb-rise" style={{ width: "100%", maxWidth: "28rem" }}>
        <div className="cb-panel__body" style={{ display: "grid", gap: "1.1rem" }}>
          <div className="cb-row" style={{ gap: "0.6rem" }}>
            <Compass size={16} style={{ color: "var(--cb-accent)" }} />
            <span className="cb-label">erro 404</span>
          </div>
          <p className="cb-display" style={{ fontSize: "2.4rem", margin: 0 }}>
            Rota não
            <br />
            encontrada
          </p>
          <p style={{ color: "var(--cb-muted)", margin: 0, fontSize: "0.9rem" }}>
            O endereço acessado não existe neste painel. As seções disponíveis são{" "}
            <span className="cb-num" style={{ color: "var(--cb-text)" }}>#treino</span>,{" "}
            <span className="cb-num" style={{ color: "var(--cb-text)" }}>#automacao</span> e, para administradores,{" "}
            <span className="cb-num" style={{ color: "var(--cb-text)" }}>#admin</span>.
          </p>
          <button type="button" className="cb-btn cb-btn--primary" onClick={onGoHome}>
            <ArrowLeftIcon size={14} />
            Voltar para o treino
          </button>
        </div>
      </div>
    </div>
  );
}
